import { getCleanUrl, getLang, getUrlWithTrailingSlash } from 'js/utils/url.util';
import { languageService } from '@theme/js/services/language.service';
import { SEO_LINK_TYPE } from '@core/js/components/system/Page/constants';
export * from 'js/components/system/Page/helpers';

/**
 * @param {Object} props
 * @param {Object} props.page
 * @param {string[]} props.allowedLocales
 * @param {string} props.defaultLocale
 * @param {boolean} props.useTrailingSlash
 * @param {SEO_LINK_TYPE} [props.seoLinkType]
 * @returns {{ href: string; hrefLang: string }[]}
 */
export const getAlternateLinks = ({ page, allowedLocales, defaultLocale, useTrailingSlash, seoLinkType }) => {
    if (!allowedLocales || seoLinkType === SEO_LINK_TYPE.DISABLED || !page) {
        return [];
    }

    const { localeToUrl = {} } = page.layoutDynamicConfig.canonicalTagConfiguration || {};
    const alternateLinks = [];
    const getDynamicSegment = () => {
        const currentLang = getLang();
        const currentCleanPath = getCleanUrl(location.pathname);
        const pageConfigPath = getCleanUrl(page.url?.[currentLang] || page.url?.[defaultLocale]);

        if (!currentCleanPath.startsWith(pageConfigPath)) {
            return '';
        }

        return currentCleanPath.slice(pageConfigPath.length);
    };

    for (const lang of allowedLocales) {
        if (lang in localeToUrl) {
            continue;
        }

        const pathLang = languageService.getPathLang(lang);

        const pathname = (() => {
            if (seoLinkType === SEO_LINK_TYPE.CURRENT_PATH || getCleanUrl(location.pathname) === '/') {
                return location.pathname;
            }

            const pagePath = page.url?.[lang] || page.url?.[defaultLocale];

            if (!pagePath) {
                return location.pathname;
            }

            if (seoLinkType === SEO_LINK_TYPE.WITH_DYNAMIC_SEGMENT) {
                return getCleanUrl(pagePath) + getDynamicSegment();
            }

            return pagePath;
        })();

        const alternateLink = `${location.origin}${pathLang ? `/${pathLang}` : ''}${getCleanUrl(pathname)}`;
        const href = getUrlWithTrailingSlash(alternateLink, useTrailingSlash);

        alternateLinks.push({ href, hrefLang: languageService.switzLangMapping[lang.replace('_', '-')] });
    }

    const xDefaultHref = alternateLinks.find(link => link.href.includes('de'));
    if (xDefaultHref) {
        const modifiedAlternateLink = { ...xDefaultHref, hrefLang:'x-default' };
        alternateLinks.push(modifiedAlternateLink);
    }

    return alternateLinks;
};

